import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPendingChangesCount } from './RequestFormChangesActions';

function useChangesCount(interval = 10000) {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.get('isAuthenticated'));

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getPendingChangesCount());

      const intervalId = setInterval(() => {
        dispatch(getPendingChangesCount());
      }, interval);

      return () => {
        clearInterval(intervalId);
      };
    }
    return undefined;
  }, [dispatch, interval, isAuthenticated]);
}

export default useChangesCount;
